const $clamp = require('clamp');

export default () => {

  function countLines(parraf) {
    var numlineas = 0;

    parraf.toArray().forEach( element => {
      numlineas = numlineas + (element.offsetHeight) / parseFloat($(element).css('line-height'));
    });
    return numlineas;
  }
  function moreItemClick(item){
    $(item).siblings(".sm-second-col").find(".cont-description").css("height", "auto");
    $(item).siblings(".sm-second-col").find(".hide-box").hide();
    $(item).closest(".item").css("margin-bottom", "20px");
    $(item).hide();
  }

  var itemTitle = $('aside[class^="cmp-sm-minute-by-minute"]').find('.content-new span:last-child');

  if (itemTitle.length > 0) {
    $clamp(itemTitle[0], {
      clamp: 2,
    });
  }

  $('aside[class^="cmp-sm-minute-by-minute"] .more-item').off('click').click(function() {
    moreItemClick(this);
  });


  $('aside[class^="cmp-sm-minute-by-minute"] .cmp-sm-content').find('.item').each(function() {
    var itemP = $(this).find('.new-description');
    var numLines = countLines(itemP);

    if (numLines > 0 && numLines <= 3) {
      $(this).find('.sm-second-col .cont-description').css('height', 'auto');
      $(this).find(".hide-box").hide();
      $(this).css('margin-bottom', '20px');
      $(this).find('.more-item').hide();
    }
  });

  // tablet
  $('aside[class^="cmp-sm-minute-by-minute"] .cmp-sm-content.cont-tablet').find('.item').each(function() {
    var itemP = $(this).find('.img-new');
    var numLines = countLines(itemP, itemP);

    if (numLines <= 8) {
      $(this).find('.new-description').css('height', 'auto');
      $(this).find('.hide-content').hide();
      $(this).find('.more-btn').hide();
    }
  });
}
